import { z } from "zod";

export const opaqueIdSchema = z
  .string()
  .min(1)
  .regex(
    // eslint-disable-next-line no-control-regex -- IDs are opaque, so controls must be rejected explicitly.
    /^(?!.*[\u0000-\u001F\u007F])\S(?:[^\u0000-\u001F\u007F]*\S)?$/u,
  )
  .refine((value) => Array.from(value).length <= 128);

export const orderConfirmationCapabilityIdSchema = z
  .string()
  .length(36)
  .regex(
    /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/u,
  );

export const canonicalSlugSchema = z
  .string()
  .min(1)
  .max(80)
  .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/u);
